import { motion } from "framer-motion";
import { UserCog, User, Linkedin } from "lucide-react";
import { TEAM } from "@/lib/mockData";
import { HOME } from "@/constants/testIds";

const EASE = [0.22, 1, 0.36, 1];

const Team = () => {
  return (
    <section id="team" className="relative py-20 md:py-28 bg-brand-surface">
      <div className="px-5 md:px-10 lg:px-16">
        <div className="flex flex-col items-center text-center mb-14 md:mb-20">
          <div className="text-xs md:text-sm font-display font-semibold tracking-[0.2em] uppercase text-brand-red mb-3">
            Meet the Team
          </div>
          <h2 className="section-heading section-heading-center font-display font-bold text-4xl md:text-5xl text-brand-ink">
            Our Leadership Team
          </h2>
          <p className="mt-6 max-w-2xl text-brand-slate text-base md:text-lg leading-relaxed">
            The recruiters, operators and strategists placing exceptional talent
            for growing companies across three continents.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {TEAM.map((m, i) => (
            <motion.div
              key={m.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: EASE, delay: 0.08 * i }}
              data-testid={HOME.teamMember(m.slug)}
              className="group relative bg-white rounded-xl border border-brand-border overflow-hidden card-soft transition-all hover:-translate-y-1 hover:shadow-[0_20px_44px_rgba(0,75,135,0.12)]"
            >
              {/* Blue top accent */}
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand-blue z-10" />

              {/* Large portrait photo */}
              <div className="relative aspect-[3/4] bg-brand-blue overflow-hidden">
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={m.name}
                    width="600"
                    height="800"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center bg-brand-blue">
                    <User className="w-24 h-24 text-white/40" strokeWidth={1.2} />
                  </div>
                )}
                {/* red badge floating */}
                <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-white shadow-md flex items-center justify-center">
                  <UserCog className="w-4 h-4 text-brand-red" strokeWidth={2} />
                </div>
              </div>

              <div className="pt-5 pb-6 px-5 flex flex-col items-center text-center">
                <div className="font-display font-bold text-brand-ink text-base md:text-lg leading-tight">
                  {m.name}
                </div>
                <div className="mt-2 text-brand-red text-sm font-display font-medium leading-snug min-h-[40px]">
                  {m.role}
                </div>

                <div className="w-full h-px bg-brand-border my-4" />

                <a
                  href={m.linkedin || "#contact"}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${m.name} on LinkedIn`}
                  className="inline-flex items-center gap-2 text-brand-blue hover:text-brand-red text-sm font-display font-semibold transition-colors"
                >
                  <Linkedin className="w-4 h-4" strokeWidth={2} fill="currentColor" />
                  Connect
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
